import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { PiPaperclipBold } from "react-icons/pi";
import { MdClose, MdSend, MdMinimize, MdExpand } from "react-icons/md";
import { useDispatch } from "react-redux";
import { getPlayerProfileDetail } from "../../store/actions";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../helpers/global_helper";
import Pusher from "pusher-js";
import Typewriter from "./chats/Typewriter";
import { addMessage } from "../../store/chat/actions";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const LiveChat = ({ ShowChatBox, setLiveChatBox, t }) => {
  const chatBoxRef = useRef(null);
  const channelRef = useRef(null);
  const typingTimeoutRef = useRef(null);

  const dispatch = useDispatch();

  const [isShow, setIsShow] = useState(true);
  const [isTyping, setIsTyping] = useState(false);
  const [dynamicHeight, setDynamicHeight] = useState("100vh");

  // State for the Typewriter animation
  const [isCompleted, setIsCompleted] = useState(false);

  const [chatClosedByAdmin, setChatClosedByAdmin] = useState(false);

  const [message, setMessage] = useState("");
  const [chats, setChats] = useState([]);
  const [channelName, setChannelName] = useState("");
  const [disabledOptions, setDesabledOptions] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const preLoginTopics = [
    {
      key: "0",
      value: "Registration",
    },
    {
      key: "1",
      value: "Login Assistance",
    },
    {
      key: "2",
      value: "Promotions and Offers",
    },
    {
      key: "3",
      value: "Game Information",
    },
  ];

  const postLoginTopics = [
    {
      key: "0",
      value: "Deposit",
    },
    {
      key: "1",
      value: "Withdrawal",
    },
    {
      key: "2",
      value: "Gameplay Assistance",
    },
    {
      key: "3",
      value: "Account Management",
    },
  ];

  // block to handle user logged In or not
  let loggedIn = window.localStorage.getItem("user_token");
  useEffect(() => {
    if (loggedIn != null && loggedIn != "") dispatch(getPlayerProfileDetail());
  }, []);

  // Function to get the channel name from localStorage
  const getStoredChannelName = () => {
    const storedChannelName = localStorage.getItem("channel_name");
    return storedChannelName || ""; // Return an empty string if no channel name is stored
  };

  // Function to store the channel name in localStorage
  const storeChannelName = (channelName) => {
    localStorage.setItem("channel_name", channelName);
  };

  // Add message to the message array in the chat UI
  const addMessageToArray = (message, sender, currentTime) => {
    setChats((prevChatArray) => {
      if (Array.isArray(prevChatArray)) {
        return [
          ...prevChatArray,
          { message: message, from: sender, timeStamp: currentTime },
        ];
      } else {
        return [{ message: message, from: sender, timeStamp: currentTime }];
      }
    });
    setMessage("");
  };

  // Function to add chats to localStorage
  const addNewChat = (message, sender) => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    const storedChats = localStorage.getItem("chats");

    const chats = storedChats ? JSON.parse(storedChats) : [];

    let randomMessageID = Math.floor(100000 + Math.random() * 900000);

    chats.push({
      message_id: randomMessageID,
      message: message,
      from: sender,
      timeStamp: currentTime,
    });

    const saveChats = chats.map(chat => ({ ...chat, localStorage: true }));
    localStorage.setItem("chats", JSON.stringify(saveChats));

    addMessageToArray(message, sender, currentTime);
    setMessage("");
  };

  // Effect to get stored chats and set the channel name from localStorage
  useEffect(() => {
    getStoredChats();
    setChannelName(getStoredChannelName());
  }, []);

  // Function to get stored chats
  const getStoredChats = () => {
    const storedChats = localStorage.getItem("chats");

    if (storedChats) {
      try {
        const parsedChats = JSON.parse(storedChats);
        console.log("Parsed stored chats:", parsedChats);
        setChats(parsedChats);
      } catch (error) {
        console.error("Error parsing stored chats:", error);
        setChats([]);
      }
    } else {
      setChats([]);
    }
  };

  // Function to add a selection message
  const addSelectionMessage = (message, sender, option1, option2) => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    const selectionMessage = {
      message: message,
      from: sender,
      option1: option1,
      option2: option2,
      timeStamp: currentTime,
    };
    setChats((prevChatArray) => [...prevChatArray, selectionMessage]);
  };

  // After generate Summary on topic click prompt guestUser to select if satisfied?
  useEffect(() => {
    // if (!loggedIn) {
      if (isCompleted) {
        const timeoutId = setTimeout(() => {
          addSelectionMessage(
            t('has_your_question_been_answered' + '?') ,
            "selection",
            "Yes",
            "No"
          );
        }, 500);
        return () => clearTimeout(timeoutId);
      }
    // }
  }, [isCompleted, t]);

  // Store message API in the database (MongoDB)
  const storeMessage = () => {
    console.log(chats);
    const userMessages = chats.filter(msg => msg.from === "user").map(msg => msg.message).join(' ');;

    // console.log(userMessages);
    // return false;

    let payload = {
      message: userMessages,
      channelName: getStoredChannelName(),
      from: "user",
    };
    makeAjax(url.MEMO_API.storeMessageInMongoDB, payload, url.MEMO_MS_EXT)
      .then((response) => {
        // connectChat();
        console.log("Store Message response: ", response);
      })
      .catch((error) => {
        console.log("Store Message error: ", error);
      });
  };

  // Handler for chat send button
  const handleSendMessage = () => {
    const channel = channelRef.current;
    storeMessage();
    if (message.trim() !== "") {
      addNewChat(message, "user");

      // condition to chat with the operator when connected to a channel
      if (channelName) {
        channel.trigger("client-user-message", {
          message: message,
        });
      } else {
        chatCompletion();
      }
    }
  };


  // AI bot Chat completion API
  const chatCompletion = () => {
    setIsTyping(true);
    // chatCompletion API call
    let payload = {
      playerQuery: message,
      channelName: channelName,
    };
    makeAjax(url.MEMO_API.chatCompletion, payload, url.MEMO_MS_EXT)
      .then((response) => {
        const messageLength = response.message.length;
        const timeout = messageLength * 100;

        if (response.message === "Please wait...") {
          connectChat();

          setTimeout(() => {
            setIsTyping(false);
            addNewChat(response.message, "operator");
          }, timeout);
        } else {
          setTimeout(() => {
            setIsTyping(false);
            addNewChat(response.message, "operator");
          }, timeout);
        }
      })
      .catch((error) => {
        console.log("Chat Completion error:", error);
        addNewChat("Error. Please try again", "error");
        setIsTyping(false);
      });

  };

  // Connect to the channel with response from generatePlayerChannel or generateGuestChannel API
  const connectChat = () => {
    makeAjax(url.MEMO_API.connectChat, [], url.MEMO_MS_EXT)
      .then((response) => {
        console.log("Chat Connect response: ", response);
        storeChannelName(response.channel_name);
        setChannelName(response.channel_name);
        console.log("ChannelName: ", channelName);
        storeMessage();
      })
      .catch((error) => {
        console.log("Chat Completion error:", error);
        addNewChat("Error. Please try again", "error");
      });
  };

  // useEffect to listen to the OperatorMessage events from the channelName
  useEffect(() => {
    if (channelName) {
      // pusher client
      const client = new Pusher("app-key", {
        // wsHost: "127.0.0.1",
        wsHost: process.env.REACT_APP_WEBSOCKET_HOST,
        wsPort: 6001,
        cluster: "mt1",
        forceTLS: false,
        encrypted: true,
        enableStats: false,
        enabledTransports: ["wss", "ws"],
        // authEndpoint: `${process.env.REACT_APP_API_URL}/api/user/memo/pusherAuth`,
        // auth: {
        //   headers: {
        //     Authorization: `Bearer ${loggedIn}`,
        //   },
        // },
      });

      const channel = client.subscribe(channelName);
      channelRef.current = channel;

      channel.bind("pusher:subscription_succeeded", () => {
        console.log("Pusher: subscription_succeeded", channel);
      });

      channel.bind("pusher:subscription_error", (e) => {
        console.error("Pusher: subscription_error", e);
      });

      channel.bind("OperatorMessage", (data) => {
        console.log("Event Triggered = ", data);
        setIsTyping(false);
        addNewChat(data.message, "operator");
      });

      // Typing event from the admin user
      channel.bind("client-admin-typing", () => {
        console.log("client typing event triggered ");
        setIsTyping(true);

        setTimeout(() => {
          setIsTyping(false);
        }, 2000);
      });

      // Message event from the admin user
      channel.bind("client-admin-message", (data) => {
        setIsTyping(false);
        addNewChat(data.message, "operator");
      });

      channel.bind("client-admin-closed-chat", () => {
        addNewChat("***Chat closed by the operator***", "notify");

        // // remove chats from localStorage
        // localStorage.removeItem('chats');
        // storeChannelName('');
        // setChannelName('');

        setChatClosedByAdmin(true);
        setChannelName("");
        storeChannelName("");
      });

      // Clean up the subscription when the component unmounts
      return () => {
        channel.unsubscribe();
        client.disconnect();
      };
    }
  }, [channelName]);

  // Function to trigger the typing event when value of input changes
  const handleTyping = () => {
    clearTimeout(typingTimeoutRef.current);

    typingTimeoutRef.current = setTimeout(() => {
      const channel = channelRef.current;
      if (channel) {
        channel.trigger("client-user-typing", { userTyping: true });
      }
    }, 300);
  };

  // Effect to handle mobile view
  useEffect(() => {
    if (window.innerWidth < 992) {
      setIsShow(true);
      setIsMobile(true);
    } else {
      setIsShow(false);
      setIsMobile(false);
    }
  }, []);

  // Generate Summary on topic click in chatbox
  const handleTopicClick = (topic) => {
    setDesabledOptions(true);
    addNewChat(topic.value, "user");
    setIsCompleted(false);
    try {
      let payload = {
        categorySelected: topic.value,
      };
      makeAjax(url.MEMO_API.generateSummary, payload, url.MEMO_MS_EXT).then(
        (response) => {
          addNewChat(response.summary, "summary");
        }
      );
    } catch (error) {
      console.log("Summary error: ", error);
      addNewChat("Error. Please try again", "error");
    }
  };

  const goBotton = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }
  // Scroll to the bottom of the chat body
  useEffect(() => {
    goBotton();
  }, [chats]);

  // Function to handle the chat close
  const handleChatClose = () => {
    if (chatClosedByAdmin) {
      setIsShow(false);
      setChats([]);
      setMessage("");
      setIsCompleted(false);
      addGreetingMessage();

      // clear chats from localStorage
      localStorage.removeItem("chats");

      setChatClosedByAdmin(false);
    } else {
      if (loggedIn) {
        dumpAllChats();
        chatCloseByUser();
        addGreetingMessage();
      } else {
        chatCloseByGuest();
      }
    }
  };

  // Function to close the chat ( guest user )
  const chatCloseByGuest = async () => {
    let channel = channelRef.current;

    if (channel) {
      channel.trigger("client-user-closed-chat");
    }

    // Clean up
    setIsShow(false);
    storeChannelName("");
    setChannelName("");
    setChats([]);
    setMessage("");
    setIsCompleted(false);

    // clear chats from localStorage
    localStorage.removeItem("chats");

    addGreetingMessage();
  };

  // Function to close the chat (logged-in user)
  const chatCloseByUser = async () => {
    let channel = channelRef.current;

    let payload = {
      channel_name: channelName,
    };

    try {
      const response = await makeAjax(url.MEMO_API.closeChatByUser, payload, url.MEMO_MS_EXT);

      if (!response) {
        console.error("Chat close request failed: No response received");
        return false;
      }

      if (channel) {
        channel.trigger("client-user-closed-chat", { userClosed: true });
      }

      // Reset chat state
      setIsShow(false);
      storeChannelName("");
      setChannelName("");
      setChats([]);
      setMessage("");
      setIsCompleted(false);

      // Clear chats from localStorage
      localStorage.removeItem("chats");
      addGreetingMessage();

      return true; // Chat closed successfully
    } catch (error) {
      console.error("Chat close error:", error);
      return false; // Indicate failure
    }
  };


  // Function to dump all chats from localStorage to the server
  const dumpAllChats = async () => {
    let payload = {
      channel_name: channelName,
      chats: localStorage.getItem("chats"),
    };

    try {
      makeAjax(url.MEMO_API.dumpAllMessages, payload, url.MEMO_MS_EXT).then(
        (response) => {
          // remove chats from localStorage
          localStorage.removeItem("chats");

          console.log("Chat dump response: ", response);
        }
      );
    } catch (error) {
      console.log("Chat dump error: ", error);
    }
  };

  // Add greeting message and topics to the chatbox
  const addGreetingMessage = () => {
    const greetingMessage =
      "Hi, Please start by selecting the topic of your query";

    // Retrieve the current chats from localStorage
    const storedChats = localStorage.getItem("chats");
    const currentChats = storedChats ? JSON.parse(storedChats) : [];

    // Check if there's already a greeting or topics message
    const hasGreeting = currentChats.some(
      (message) => message.from === "greeting"
    );
    const hasTopics = currentChats.some((message) => message.from === "topics");

    // Create a copy of current chats to update
    let updatedChats = [...currentChats];

    // Add the greeting message only if it doesn't exist
    if (!hasGreeting) {
      const greetingChat = {
        message_id: Math.floor(100000 + Math.random() * 900000),
        message: greetingMessage,
        from: "greeting",
        timeStamp: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      };
      updatedChats.push(greetingChat);
    }

    // Add the topics message only if it doesn't exist
    if (!hasTopics) {
      const topicsChat = {
        message_id: Math.floor(100000 + Math.random() * 900000),
        message: "",
        from: "topics",
        timeStamp: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      };
      updatedChats.push(topicsChat);
    }

    // Update localStorage and state only if changes were made
    if (updatedChats.length > currentChats.length) {
      localStorage.setItem("chats", JSON.stringify(updatedChats));
      setChats(updatedChats);
    }
  };

  // Adding greeting message and topics to the chatbox on component mount
  useEffect(() => {
    addGreetingMessage();
  }, []);

  // Function to handle image upload
  const handleImageUpload = async (e) => {
    const image = e.target.files[0];

    if (image) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageDataURL = e.target.result;
        addNewChat(imageDataURL, "image");
      };
      reader.readAsDataURL(image);

      // Connect chat to the Operator when image is uploaded
      await connectChat();
    } else {
      console.log("Could not upload the image", e);
    }
  };

  // Handle selection button click for guest user
  const handleSelectionButtonClick = (option) => {
    if (option === "No") {
      connectChat();

      addNewChat("Connecting chat ...", "notify");
    } else if (option === "Yes") {
      setIsShow(false);
      storeChannelName("");
      setChannelName("");
      // setChats([]);
      setMessage("");
      setIsCompleted(false);
      if (isMobile && setLiveChatBox)
        setLiveChatBox(false);
      addGreetingMessage();
    }
  };

  useEffect(() => {
    goBotton();
    if (!isShow) {
      const saveChats = chats.map(chat => ({ ...chat, localStorage: true }));
      localStorage.setItem("chats", JSON.stringify(saveChats));
    } else {
      getStoredChats();
    }

  }, [isShow, isCompleted])

  return (
    <>
      {ShowChatBox &&
        <div className={`chat-bar-collapsible ${isShow ? 'open' : ''}`}>
          {/* ChatBox Header */}
          <div className='collapsible'
            onClick={() => setIsShow(!isShow)}
          >
            {/* Heading Text */}
            <p style={{ color: "#ccc" }}>Chat with us!</p>

            {/* Action Buttons */}
            <div>
              {isShow ? (
                <MdMinimize
                  onClick={() => {
                    setIsShow(false);
                    if (isMobile && setLiveChatBox)
                      setLiveChatBox(false);
                  }}
                  style={{
                    cursor: "pointer",
                    color: "#ccc",
                    fontSize: "20px",
                  }}
                />
              ) : (
                <MdExpand
                  onClick={() => setIsShow(true)}
                  style={{
                    cursor: "pointer",
                    color: "#ccc",
                    fontSize: "20px",
                  }}
                />
              )}

              <MdClose
                onClick={(e) => {
                  e.preventDefault();
                  handleChatClose();
                  if (isMobile && setLiveChatBox)
                    setLiveChatBox(false);
                }}
                style={{
                  cursor: "pointer",
                  color: "#ccc",
                  fontSize: "20px",
                }}
              />
            </div>
          </div>

          {/* Collapsible Section */}
          {isShow && (
            <div className="content">
              {/* ChatBox Body */}
              <div className="full-chat-block">
                <div className="outer-container">
                  <div ref={chatBoxRef} className="chat-container">
                    {/* Chat chats mapping according to the sender type */}
                    {chats?.map((message, index) => {
                      switch (message.from) {
                        case "greeting": {
                          return (
                            <div key={index} className="chatbox" >
                              <div className="category">
                                <div className="chat-text ">
                                  <p className="chat-label">{message.message}</p>
                                </div>
                              </div>
                            </div>
                          );
                        }

                        case "topics": {
                          return (
                            <div key={index} className="accordion">
                              {loggedIn
                                ? postLoginTopics.map((topic) => {
                                  return (
                                    <button
                                      className="accordian-tab-active"
                                      key={topic.key}
                                      disabled={disabledOptions}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleTopicClick(topic);
                                      }}
                                    >
                                      <p>{topic.value}</p>
                                    </button>
                                  );
                                })
                                : preLoginTopics.map((topic) => {
                                  return (
                                    <button
                                      className="accordian-tab-active"
                                      key={topic.key}
                                      disabled={disabledOptions}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleTopicClick(topic);
                                      }}
                                    >
                                      <p>{topic.value}</p>
                                    </button>
                                  );
                                })}
                            </div>
                          );
                        }

                        case "summary": {
                          return (
                            <div className="summary"
                              key={index}>
                              <div className="chat incoming"
                                key={index}>
                                <p key={index} >
                                  {isCompleted || message.localStorage ? (
                                    message.message
                                  ) : (
                                    <>
                                      {!message.localStorage &&
                                        <Typewriter
                                          text={message.message}
                                          delay={10}
                                          isCompleted={isCompleted}
                                          setIsCompleted={setIsCompleted}
                                          goBotton={goBotton}
                                          message={message}
                                          setDesabledOptions={setDesabledOptions}
                                          chats={chats}
                                        />
                                      }
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="chat-time-out">
                                <p>{message.timeStamp}</p>
                              </div>
                            </div>
                          );
                        }

                        case "user": {
                          return (
                            <div
                              key={index} className="d-flex justify-content-end">
                              <div className="chat-time-in">
                                <p>{message.timeStamp}</p>
                              </div>
                              <div className="chat outgoing">
                                <p>{message.message}</p>
                              </div>
                            </div>
                          );
                        }

                        case "operator": {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignContent: "center",
                                width: "100%",
                                height: "fit-content",
                              }}
                            >
                              <div className="incoming ">
                                <p>{message.message}</p>
                              </div>
                              <div
                                style={{
                                  fontSize: "5px",
                                  fontWeight: "lighter",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <p>{message.timeStamp}</p>
                              </div>
                            </div>
                          );
                        }

                        case "system": {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignContent: "center",
                                width: "100%",
                                height: "fit-content",
                              }}
                            >
                              <div
                                style={{
                                  float: "left",
                                  clear: "both",
                                  maxWidth: "85%",
                                  width: "fit-content",
                                  border: "1px solid #ccc",
                                  color: "#ccc",
                                  padding: "7px",
                                  borderRadius: "5px",
                                  marginBottom: "10px",
                                  backgroundColor: "#201E21",
                                }}
                              >
                                <p>{message.message}</p>
                              </div>
                              <div
                                style={{
                                  fontSize: "5px",
                                  fontWeight: "lighter",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <p>{message.timeStamp}</p>
                              </div>
                            </div>
                          );
                        }

                        case "notify": {
                          return (
                            <div
                              key={index}
                              className="chat outgoing"
                            >
                              <p>{message.message}</p>
                            </div>
                          );
                        }

                        case "error": {
                          return (
                            <div
                              key={index}
                              className="chat outgoing"
                            >
                              <p>{message.message}</p>
                            </div>
                          );
                        }

                        case "image": {
                          return (
                            <div
                              key={index}
                              style={{
                                float: "right",
                                clear: "both",
                                maxWidth: "85%",
                                border: "1px solid #ccc",
                                backgroundColor: "#201E21",
                                color: "#ccc",
                                padding: "7px",
                                borderRadius: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              <img
                                loading="lazy"
                                src={message.message}
                                alt="image"
                                style={{ width: "100%" }}
                              />
                            </div>
                          );
                        }

                        case "selection": {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <div className="chat outgoing">
                                <p>{message.message}</p>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  gap: '6px'
                                }}>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSelectionButtonClick(message.option1);
                                  }}

                                >
                                  {message.option1}
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSelectionButtonClick(message.option2);
                                  }}>
                                  {message.option2}
                                </button>
                              </div>
                            </div>
                          );
                        }
                      }
                    })}

                    {/* Typing Indicator */}
                    {isTyping && (
                      <div className="error-typing">
                        <p>Typing ...</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ChatBox Footer */}
              <div className="chat-bar-input-block">
                <div className="chat-bar-icons">
                  <label
                    style={{
                      cursor: "pointer",
                      color: "#ccc",
                      fontSize: "20px",
                    }}
                  >
                    <PiPaperclipBold />
                    <input
                      type="file"
                      style={{
                        display: "none",
                      }}
                      onChange={(e) => {
                        e.preventDefault();
                        handleImageUpload(e);
                      }}
                      // disabled={!loggedIn && channelName === ""}
                      title="Upload Image"
                    />
                  </label>
                </div>

                {/* Input form */}
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSendMessage();
                  }}
                  style={{ width: '100%' }}
                >
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    gap: '6px',
                    alignItems: 'center'
                  }}>
                    <input
                      placeholder="Enter your message"
                      style={
                        !loggedIn && channelName === ""
                          ? { backgroundColor: '#505050b9' }
                          : { backgroundColor: 'var(--vs-card-bg)' }
                      }
                      value={message}
                      onChange={(e) => {
                        e.preventDefault();
                        setMessage(e.target.value);
                        handleTyping();
                      }}
                    />
                    <MdSend
                      style={{
                        cursor: "pointer",
                        fontSize: "30px",
                        color: "#ccc",
                        backgroundColor: "#65337e",
                        padding: "4px",
                        width: "15%",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSendMessage();
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          )}
        </div >
      }
    </>
  );
};

LiveChat.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(LiveChat);
